import { render, staticRenderFns } from "./TicketInformation.vue?vue&type=template&id=c37b8054&"
import script from "./TicketInformation.vue?vue&type=script&lang=js&"
export * from "./TicketInformation.vue?vue&type=script&lang=js&"
import style0 from "./TicketInformation.vue?vue&type=style&index=0&id=c37b8054&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports